"use strict";

var _regeneratorRuntime = require("/app/node_modules/@babel/runtime/helpers/regeneratorRuntime.js").default;

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck.js").default;

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass.js").default;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var Events;

Events = /*#__PURE__*/function () {
  function Events(instance) {
    var _this2 = this;

    _classCallCheck(this, Events);

    this.instance = instance;
    this._events = {};

    if (this.instance.on != null || this.instance.once != null || this.instance.removeAllListeners != null) {
      throw new Error("An Emitter already exists for this object");
    }

    this.instance.on = function (name, cb) {
      return _this2._addListener(name, "many", cb);
    };

    this.instance.once = function (name, cb) {
      return _this2._addListener(name, "once", cb);
    };

    this.instance.removeAllListeners = function () {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (name != null) {
        return delete _this2._events[name];
      } else {
        return _this2._events = {};
      }
    };
  }

  _createClass(Events, [{
    key: "_addListener",
    value: function _addListener(name, status, cb) {
      var base;

      if ((base = this._events)[name] == null) {
        base[name] = [];
      }

      this._events[name].push({
        cb: cb,
        status: status
      });

      return this.instance;
    }
  }, {
    key: "listenerCount",
    value: function listenerCount(name) {
      if (this._events[name] != null) {
        return this._events[name].length;
      } else {
        return 0;
      }
    }
  }, {
    key: "trigger",
    value: function trigger(name) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var e, promises;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (name !== "debug") {
                  _this.trigger("debug", "Event triggered: ".concat(name), args);
                }

                if (!(_this._events[name] == null)) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return");

              case 4:
                _this._events[name] = _this._events[name].filter(function (listener) {
                  return listener.status !== "none";
                });
                promises = _this._events[name].map( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(listener) {
                    var e, returned;
                    return _regeneratorRuntime().wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!(listener.status === "none")) {
                              _context.next = 2;
                              break;
                            }

                            return _context.abrupt("return");

                          case 2:
                            if (listener.status === "once") {
                              listener.status = "none";
                            }

                            _context.prev = 3;
                            returned = typeof listener.cb === "function" ? listener.cb.apply(listener, args) : void 0;

                            if (!(typeof (returned != null ? returned.then : void 0) === "function")) {
                              _context.next = 11;
                              break;
                            }

                            _context.next = 8;
                            return returned;

                          case 8:
                            return _context.abrupt("return", _context.sent);

                          case 11:
                            return _context.abrupt("return", returned);

                          case 12:
                            _context.next = 19;
                            break;

                          case 14:
                            _context.prev = 14;
                            _context.t0 = _context["catch"](3);
                            e = _context.t0;

                            if ("name" !== "error") {
                              _this.trigger("error", e);
                            }

                            return _context.abrupt("return", null);

                          case 19:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, null, [[3, 14]]);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());
                _context2.next = 8;
                return Promise.all(promises);

              case 8:
                return _context2.abrupt("return", _context2.sent.find(function (x) {
                  return x != null;
                }));

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](0);
                e = _context2.t0;

                if ("name" !== "error") {
                  _this.trigger("error", e);
                }

                return _context2.abrupt("return", null);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 11]]);
      }))();
    }
  }]);

  return Events;
}();

module.exports = Events;